
export enum OfferReviewDecision {
  Approve = 'approve',
  Deny = 'deny'
};

export class OfferReview {
  readonly userId: string;
  readonly reviewedAt: Date;
  readonly decision: OfferReviewDecision;

  constructor(deriveFrom?: Partial<OfferReview>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    this.reviewedAt = new Date(this.reviewedAt);
  }
}